import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookiesStorageService {
  constructor() {}

  setCookie(key: string, value: any, expirationDays: number = 1): void {
    const date = new Date();
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = `${key}=${JSON.stringify(value)}; ${expires}; path=/`;
  }

  getCookie(key: string): any {
    const name = key + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        const cookieValue = cookie.substring(name.length, cookie.length);
        try {
          return JSON.parse(cookieValue);
        } catch (e) {
          return cookieValue;
        }
      }
    }
    return null;
  }

  removeCookie(key: string): void {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  clearCookies(): void {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  }

  cookieExists(key: string): boolean {
    return !!this.getCookie(key);
  }

  getAllCookies(): { [key: string]: any } {
    const cookies: { [key: string]: any } = {};
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
      const cookie = cookieArray[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      cookies[name.trim()] = this.getCookie(name.trim());
    }

    return cookies;
  }

  setCookieWithOptions(
    key: string,
    value: any,
    options: { expires?: number; path?: string; domain?: string; secure?: boolean },
  ): void {
    let cookieString = `${key}=${JSON.stringify(value)}`;

    if (options.expires) {
      const date = new Date();
      date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
      cookieString += `; expires=${date.toUTCString()}`;
    }

    if (options.path) {
      cookieString += `; path=${options.path}`;
    }

    if (options.domain) {
      cookieString += `; domain=${options.domain}`;
    }

    if (options.secure) {
      cookieString += `; secure`;
    }

    document.cookie = cookieString;
  }
}
